// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3zQMX","inputWrap":"styles_inputWrap__3OQNi","input":"styles_input__1aqrC"};